import { LegalShell, Sec } from '../components/LegalShell';

/**
 * Política de Privacidad de ÁGORA (pública). Requerida por la pantalla de
 * consentimiento OAuth de Google. Contenido tratado como borrador institucional:
 * debe validarlo el área legal de la institución antes de un uso definitivo.
 */
export function PrivacidadPage() {
  return (
    <LegalShell
      titulo="Política de Privacidad"
      actualizado="21 de julio de 2026"
      otro={{ href: '/terminos', texto: 'Condiciones del Servicio' }}
      intro="ÁGORA es una plataforma de innovación participativa operada por Grupo InteligencIA para que instituciones públicas, universidades y equipos profesionales conduzcan procesos deliberativos trazables. Esta política explica qué datos tratamos, con qué finalidad y qué derechos tenés sobre ellos."
    >
      <Sec titulo="1. Responsable del tratamiento">
        <p>
          El tratamiento de los datos lo realiza la institución que contrata ÁGORA (el
          «Responsable institucional»), con el soporte técnico de Grupo InteligencIA como
          encargado de la operación de la plataforma. Para consultas de privacidad podés
          escribir a <span className="text-content">privacidad@inteligencia.com.gt</span>.
        </p>
      </Sec>

      <Sec titulo="2. Datos que tratamos">
        <p>Según cómo uses la plataforma, tratamos:</p>
        <ul className="list-disc pl-5">
          <li>
            <strong className="text-content">Identidad y cuenta:</strong> nombre, correo
            institucional y, si ingresás con Google, los datos básicos de perfil que Google
            comparte (identificador de cuenta, nombre y correo).
          </li>
          <li>
            <strong className="text-content">Participación:</strong> los aportes que hacés en
            un proceso (texto, votos, posiciones y, en fases posteriores, audio y archivos), con
            su autoría y el momento en que se registraron.
          </li>
          <li>
            <strong className="text-content">Acceso de sala:</strong> el código de sesión y el
            PIN usados para entrar a un taller presencial.
          </li>
          <li>
            <strong className="text-content">Datos técnicos:</strong> registros mínimos de uso
            necesarios para la seguridad y el funcionamiento del servicio.
          </li>
        </ul>
      </Sec>

      <Sec titulo="3. Para qué usamos los datos">
        <ul className="list-disc pl-5">
          <li>Operar los procesos participativos y registrar los aportes de forma trazable.</li>
          <li>Autenticarte y proteger tu cuenta y la de tu institución.</li>
          <li>
            Construir las propuestas y artefactos del proceso, donde cada conclusión puede
            regresar a la evidencia que la respalda.
          </li>
          <li>Reconocer la coautoría de quienes participan.</li>
        </ul>
      </Sec>

      <Sec titulo="4. Inicio de sesión con Google">
        <p>
          Si elegís «Continuar con Google», usamos el protocolo OAuth 2.0 / OpenID Connect
          únicamente para verificar tu identidad y crear o vincular tu cuenta. Solo recibimos
          los datos básicos de perfil que Google comparte para el inicio de sesión. No
          accedemos a tu correo, contactos ni a otros servicios de Google, ni publicamos nada
          en tu nombre.
        </p>
      </Sec>

      <Sec titulo="5. Uso de inteligencia artificial">
        <p>
          Cuando la plataforma emplea asistencia de inteligencia artificial (por ejemplo, para
          agrupar aportes o redactar borradores), toda salida cita la evidencia que la respalda
          y lo no respaldado se marca como tal. La IA propone; la decisión siempre es humana.
        </p>
      </Sec>

      <Sec titulo="6. Con quién se comparten">
        <p>
          Los datos del proceso pertenecen a la institución responsable. No vendemos datos
          personales ni los compartimos con terceros con fines publicitarios. Solo recurrimos a
          proveedores tecnológicos necesarios para operar el servicio, sujetos a
          confidencialidad.
        </p>
      </Sec>

      <Sec titulo="7. Conservación">
        <p>
          Conservamos los datos mientras dure la relación con la institución y el tiempo
          necesario para cumplir obligaciones legales y de auditoría del proceso participativo.
          Los registros de aportes forman parte del acta del proceso y de su trazabilidad.
        </p>
      </Sec>

      <Sec titulo="8. Seguridad">
        <p>
          Aplicamos medidas técnicas y organizativas razonables: cifrado en tránsito (HTTPS),
          almacenamiento de contraseñas y PIN con algoritmos de hash robustos, y control de
          acceso por rol.
        </p>
      </Sec>

      <Sec titulo="9. Tus derechos">
        <p>
          Podés solicitar acceso, rectificación o eliminación de tus datos personales, dentro de
          los límites de la normativa aplicable y de la integridad del acta del proceso.
          Dirigí tu solicitud a la institución responsable o a{' '}
          <span className="text-content">privacidad@inteligencia.com.gt</span>.
        </p>
      </Sec>

      <Sec titulo="10. Menores de edad">
        <p>
          ÁGORA está dirigida a procesos institucionales y no está destinada a menores de edad
          sin la autorización correspondiente de la institución.
        </p>
      </Sec>

      <Sec titulo="11. Cambios a esta política">
        <p>
          Podemos actualizar esta política. Publicaremos la versión vigente en esta página con su
          fecha de última actualización.
        </p>
      </Sec>

      <Sec titulo="12. Ley aplicable">
        <p>
          Esta política se rige por las leyes de la República de Guatemala.
        </p>
      </Sec>
    </LegalShell>
  );
}
